import React from "react";
import { Link } from "react-router-dom";

import EntityJocRepInfoSplashRow from "./../components/entityJocRepInfoSplashRow";

class EntityJocRepInfoSplash extends React.Component {
  render() {
    const { entityJOCDataRetreived } = this.props;

    if (entityJOCDataRetreived) {
      return (
        <div className="col container-top-sm">
          <div className="card text-center">
            <div className="card-header">
              <h5>Joc Representatives</h5>
            </div>
            <div className="card-body ">
              <table width="100%">
                <thead className="leftComponents card-rowHeader">
                  <tr>
                    <th>Name</th>
                    <th>Surame</th>
                    <th>Cell</th>
                  </tr>
                </thead>
                {entityJOCDataRetreived.map((entityUser) => (
                  <EntityJocRepInfoSplashRow
                    name={entityUser.name}
                    surname={entityUser.surname}
                    key={entityUser.id}
                    cell={entityUser.cell}
                    entityUserID={entityUser.id}
                  />
                ))}
              </table>
            </div>

            <div className="card-footer text-muted"></div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="col container-top-sm">
          <div className="card text-center">
            <div className="card-header">
              <h5>Joc Representatives</h5>
            </div>
            <div className="card-body">
              <table width="100%">
                <thead className="leftComponents card-rowHeader">
                  <tr>
                    <th>Name</th>
                    <th>Surame</th>
                    <th>Cell</th>
                    <th>Email</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th colSpan={4}>
                      {" "}
                      A fresh start. :-) <br />
                      No Joc Representatives loaded yet.
                    </th>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="card-footer text-muted"></div>
          </div>
        </div>
      );
    }
  }
}

export default EntityJocRepInfoSplash;
